import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "icon", "spinner", "error"]

  connect() {
    // No auto-detect on load. Only detect on user action.
  }

  detect(event) {
    if (event) event.preventDefault();
    this.clearError();
    // Show Spinner
    if (this.hasIconTarget && this.hasSpinnerTarget) {
      this.iconTarget.classList.add("hidden")
      this.spinnerTarget.classList.remove("hidden")
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // Fetch city from OpenStreetMap (free)
          fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`)
            .then(response => response.json())
            .then(data => {
              const address = data.address;
              const city = address.city || address.town || address.municipality || address.village || address.state;
              if (city && this.hasInputTarget) {
                this.inputTarget.value = city;
                // this.inputTarget.form.submit(); // Auto-search
              }
            })
            .finally(() => {
              if (this.hasIconTarget && this.hasSpinnerTarget) {
                this.iconTarget.classList.remove("hidden")
                this.spinnerTarget.classList.add("hidden")
              }
            });
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            this.showGeolocationModal();
          } else {
            let message = "Unable to retrieve location.";
            switch (error.code) {
              case error.POSITION_UNAVAILABLE:
                message = "Location information is unavailable. Please enter your city manually.";
                break;
              case error.TIMEOUT:
                message = "Location request timed out. Please try again or enter your city manually.";
                break;
            }
            this.showError(message);
          }
          if (this.hasIconTarget && this.hasSpinnerTarget) {
            this.iconTarget.classList.remove("hidden")
            this.spinnerTarget.classList.add("hidden")
          }
        }
      );
    } else {
      this.showGeolocationModal();
      if (this.hasIconTarget && this.hasSpinnerTarget) {
        this.iconTarget.classList.remove("hidden")
        this.spinnerTarget.classList.add("hidden")
      }
    }
  }

  showGeolocationModal() {
    // Use Turbo to render the modal partial
    const modal = document.createElement("div");
    modal.innerHTML = `<turbo-frame id=\"modal\"></turbo-frame>`;
    document.body.appendChild(modal);
    fetch("/shared/geolocation_modal_content")
      .then(response => response.text())
      .then(html => {
        document.getElementById("modal").innerHTML = html;
      });
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = message;
      this.errorTarget.classList.remove("hidden");
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.textContent = "";
      this.errorTarget.classList.add("hidden");
    }
  }
}
